let simplePopoverLast = null;
let simplePopoverLastBaseElem = null;
/**
 *  in cases where you need a popover and cant use react/antd popover
 * (f.e. in jspreadsheets or other third party reactless contexts)
 *  you can use this function
 * @param baseElement: HTMLElement the bases element where the popover should be shown
 * @param content: HTMLElement the content of the popover
 */
export function simplePopover(baseElement: HTMLElement, content: HTMLElement | string) {
  if (simplePopoverLast) {
    document.body.removeChild(simplePopoverLast);
    simplePopoverLast = null;
  }
  if (simplePopoverLastBaseElem) {
    simplePopoverLastBaseElem.onmouseout = null;
    simplePopoverLastBaseElem = null;
  }
  const rects = baseElement.getClientRects();
  if (rects?.length > 0) {
    const div = document.createElement("div");
    div.setAttribute("class", "ant-tooltip-inner");
    div.style.cssText =
      "position: absolute; z-Index:100000; left: " +
      rects[0].x +
      "px; top: " +
      (rects[0].y + rects[0].height + 10) +
      "px;padding:10px; border: 1px solid black; border-radius:10px";
    if (typeof content === "string") {
      div.innerText = content;
    } else {
      div.appendChild(content);
    }
    simplePopoverLast = div;
    baseElement.onmouseout = function () {
      if (simplePopoverLast) {
        document.body.removeChild(simplePopoverLast);
        simplePopoverLast = null;
      }
      if (simplePopoverLastBaseElem) {
        simplePopoverLastBaseElem.onmouseout = null;
        simplePopoverLastBaseElem = null;
      }
    };
    simplePopoverLastBaseElem = baseElement;
    document.body.appendChild(div);
  }
}
